import React, { useEffect, useState } from "react";
import { Time } from "../assets/time";
import { Costumization } from "../assets/costumization";
import { Secure } from "../assets/secure";
import { System } from "../assets/systems";
import highlightWiseMate from "../hooks/highlightWord";
import { renderHTML } from "../hooks/htmlToText";

type TCard = {
  title: string;
  subtitle: string;
  index: number;
  isLastCard: boolean;
};

export const Card = ({ title, subtitle, index, isLastCard }: TCard) => {
  const images = [<Time />, <Costumization />, <Secure />, <System />];
  const isEven = index % 2 === 0;
  const [isVisible, setIsVisible] = useState(false);
  const cardRef = React.useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );

    if (cardRef.current) observer.observe(cardRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={cardRef}
      className={`flex gap-8 flex-col items-center lg:flex-row lg:text-start ${
        isEven ? "" : "lg:flex-row-reverse"
      }`}
    >
      <div
        className={`${
          isVisible
            ? isEven
              ? "animate-slideInLeft"
              : "animate-slideInRight"
            : "opacity-0"
        }`}
      >
        {images[index]}
      </div>

      <div
        className={`flex flex-col gap-6 ${
          isVisible
            ? isEven
              ? "animate-slideInRight"
              : "animate-slideInLeft"
            : "opacity-0"
        }`}
      >
        <p className="text-primary-700 font-600 text-[24px] md:text-[32px] tracking-[-0.96px]">
          {title}
        </p>
        <p className="text-neutral-200 text-[16px] md:text-[18px] font-500">
          {isLastCard
            ? highlightWiseMate(subtitle, "font-500")
            : renderHTML(subtitle)}
        </p>
      </div>
    </div>
  );
};
